import React, { useEffect, useState  } from 'react';
 import SeoHelmet from "../components/SeoHelmet";
import ContactForm from "../components/ContactForm";
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";

import slide1 from '../assets/img/banner_bg.jpg';

import Banner1 from '../assets/img/banner_img.png';
import Icon1 from '../assets/img/icon1.png';


import Brand1 from '../assets/img/brand_bg.svg';
import Logo1 from '../assets/img/khazana.svg';
import Logo2 from '../assets/img/mercedes.svg'; 
import Logo3 from '../assets/img/jktyre.svg';
import Logo4 from '../assets/img/esro.svg';
import Logo5 from '../assets/img/emerald.svg';
import Logo6 from '../assets/img/noku.jpg';
import Logo7 from '../assets/img/muru.svg';
import Logo8 from '../assets/img/hindusthan.svg';
import Logo9 from '../assets/img/lily_beach.svg';
import Logo10 from '../assets/img/volvo.svg';
import Logo11 from '../assets/img/coco.svg';
import Logo12 from '../assets/img/parrys.svg';
import Logo13 from '../assets/img/mrf.svg';
import Logo14 from '../assets/img/ashok.svg';
import Logo15 from '../assets/img/eicher.svg';
import Logo16 from '../assets/img/sundram.svg';
import Logo17 from '../assets/img/hwashin.svg';
import Logo18 from '../assets/img/tvs.svg';
import Logo19 from '../assets/img/the_ritz.svg';
import Logo20 from '../assets/img/kureghivaru.svg';
import Logo21 from '../assets/img/island.svg';


import Inds1 from '../assets/img/industrial&manufacturing.jpg';
import Inds2 from '../assets/img/hospitality&resorts.jpg';
import Inds3 from '../assets/img/retail&brandspaces.jpg';
import Inds4 from '../assets/img/corporate&admin.jpg';
import Inds5 from '../assets/img/healthcareclinics&wellness.jpg';
import Inds6 from '../assets/img/educationalinstitutions.svg';
import Inds7 from '../assets/img/governmentpolice&defense.jpg';



import Amb1 from '../assets/img/ambience_img_1.jpg';
import Amb2 from '../assets/img/ambience_img_2.jpg';
import Amb3 from '../assets/img/ambience_img_3.jpg';
import Amb4 from '../assets/img/ambience_img_4.jpg';
import Amb5 from '../assets/img/ambience_img_5.svg';




import Work1 from '../assets/img/work_img_1.png';
import Work2 from '../assets/img/work_img_2.png';
import Work3 from '../assets/img/work_img_3.png';



import Get1 from '../assets/img/get_in_touch_bg.jpg';
import Get2 from '../assets/img/get-in-tuch.png';



import Pro1 from '../assets/img/process_img_1.svg';
import Pro2 from '../assets/img/arrow_right.svg';
import Pro3 from '../assets/img/process_img_2.svg';
import Pro4 from '../assets/img/arrow_right.svg';
import Pro5 from '../assets/img/process_img_3.svg';
import Pro6 from '../assets/img/arrow_right.svg';
import Pro7 from '../assets/img/process_img_4.svg';
import Pro8 from '../assets/img/arrow_down.svg';
import Pro9 from '../assets/img/process_img_5.svg';
import Pro10 from '../assets/img/back_arrow.svg';
import Pro11 from '../assets/img/process_img_6.svg';
import Pro12 from '../assets/img/back_arrow.svg';
import Pro13 from '../assets/img/process_img_7.svg';

import slide2 from '../assets/img/slide2.svg';
import slide3 from '../assets/img/slide3.jpg';



import Global1 from '../assets/img/global_footprint.png';



import User1 from '../assets/img/user_1.jpg';
import User2 from '../assets/img/user_2.jpg';
import User3 from '../assets/img/user_3.jpg';




const HomePage = () => {

  const [activeVideo, setActiveVideo] = useState(null);

  const handleOpenModal = (videoSrc) => {
    setActiveVideo(videoSrc); // Set the active video source
  };

  const handleCloseModal = () => {
    setActiveVideo(null); // Clear the active video source
  };

  useEffect(() => {

    if (window.Swiper) {

      const swiperQuiz = new window.Swiper(".animeslide", {
       // effect: "fade",
        loop: true,
        autoplay: 5000,
        speed: 900,
        autoplay: {
          delay: 2800,
        },
        centeredSlides: true,
        pagination: {
          el: ".animeslide-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".animeslide-button-next",
          prevEl: ".animeslide-button-prev",
        },

        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        runCallbacksOnInit: true,
      });


      const swiper = new window.Swiper(".instpostslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
            navigation: {
              nextEl: ".testi-button-next",
              prevEl: ".testi-button-prev",
            },

          },
          // You can add more breakpoints if needed
        },

      });


    }




  }, []);

  return (

    <>
      <SeoHelmet />



      {/* Modal Component */}
      <ContactModal />

      <section>
        <div className="swiper animeslide homebaslide">
          <div className="swiper-wrapper">

            <div className="swiper-slide animeslide-slide slide1" style={{ backgroundImage: `url(${slide1})` }}>
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Uniforms with a<br></br> Purpose</h2>
                      
                        <p>Tailored to Inspire, Impress and Influence</p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
                      </div>
                    </div>
                  </div>
                
                </div>

              </div>
            </div>
             <div className="swiper-slide animeslide-slide slide1" style={{ backgroundImage: `url(${slide2})` }}>
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Spaces Redefined,<br></br>  Redesigned</h2>
                      
                        <p>Complete Room Essentials & Furnishings<br></br>  Crafted for Invisible Luxury</p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
                      </div>
                    </div>
                  </div>
                  
                </div>

              </div>
            </div> 
             <div className="swiper-slide animeslide-slide slide1" style={{ backgroundImage: `url(${slide3})` }}>
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Legacy in Every Stitch</h2>
                      
                        <p>Shaping brands Since 1973</p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Let’s Get Started</span><img src={Icon1} alt="" /></a>
                      </div>
                    </div>
                  </div>
                  
                </div>

              </div>
            </div> 


          </div>
          
        </div>
      </section>
      <section className="brands_section" style={{ backgroundImage: `url(${Brand1})` }}>
        <div className="container">
          <div className="brands_content" >
            <h2>Brands That Wear Us with Pride</h2>
            <p>From renowned luxury hotels to quick service restaurants and airlines, industry<br></br> leaders trust us with their uniform needs</p>
          </div>
          <div className="brands_logo">
            <img src={Logo1} alt="" className='logom' />
            <img src={Logo2} alt="" className='logom' />
            <img src={Logo3} alt="" className='logom' />
            <img src={Logo4} alt="" className='logom' />
            <img src={Logo5} alt="" className='logom' />
            <img src={Logo6} alt="" className='logom' />
            <img src={Logo7} alt="" className='logom' />
            <img src={Logo8} alt="" className='logom' />
            <img src={Logo9} alt="" className='logom' />
            <img src={Logo10} alt="" className='logom' />
            <img src={Logo11} alt="" className='logom' />
            <img src={Logo12} alt="" className='logom' />
            <img src={Logo13} alt="" className='logom' />
            <img src={Logo14} alt="" className='logom' />
            <img src={Logo15} alt="" className='logom' />
            <img src={Logo16} alt="" className='logom' />
            <img src={Logo17} alt="" className='logom' />
            <img src={Logo18} alt="" className='logom' />
            <img src={Logo19} alt="" className='logom' />
            <img src={Logo20} alt="" className='logom' />
            <img src={Logo21} alt="" className='island' />
          </div>
        </div>
      </section>
      <section className="brands_section industries_we_dress">
        <div className="brands_content industries_content" >
          <h2>Industries We Dress with Purpose</h2>
          <p>Each sector is unique. So is the uniform we design for it.</p>
        </div>
        <div className="industries_we_dress_with_purpose indmbrer" >
          <div className="container">
            <div className="row">
              <div className="col-sm-5" >
                <div className="inds_1" style={{ backgroundImage: `url(${Inds1})` }} onClick={() =>
                      window.open("/product/industrial-manufacturing", "_self")
                    }>
                  
                    <h3>Industrial & Manufacturing</h3>
                    <p>Built for Durability. Designed for Safety.</p>
                  
                </div>
                <div className="inds_1 brmbr" style={{ backgroundImage: `url(${Inds2})` }}  onClick={() =>
                      window.open("/product/hospitality-resorts", "_self")
                    }>

                  
                    <h3>Hospitality & Resorts</h3>
                    <p>Where Uniforms Reflect Warmth & Elegance</p>
                  
                </div>
              </div>
              <div className="col-sm-7">
                <div className="row">
                  <div className="col-sm-6">
                    <div className="inds_3" style={{ backgroundImage: `url(${Inds3})` }} onClick={() =>
                      window.open("/product/retail-brand-spaces", "_self")
                    }>

                      
                        <h3>Retail & Brand Spaces</h3>
                        <p>Retail-Ready Uniforms with Brand Impact</p>
                      
                    </div>
                  </div>
                  <div className="col-sm-6" >
                    <div className="inds_3" style={{ backgroundImage: `url(${Inds4})` }} onClick={() =>
                      window.open("/product/corporate-admin", "_self")
                    }>

                      
                        <h3>Aviation</h3>
                        <p>Polished Look for Everyday Impact</p>
                      
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="inds_4" style={{ backgroundImage: `url(${Inds5})` }} onClick={() =>
                      window.open("/product/healthcare-clinics-wellness", "_self")
                    }>

                      
                        <h3>Healthcare, Clinics & Wellness</h3>
                        <p>Dependable Wear for Demanding Roles</p>
                      
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="inds_3" style={{ backgroundImage: `url(${Inds6})` }} onClick={() =>
                      window.open("/product/educational-institutions", "_self")
                    }>

                      
                        <h3>Educational Institutions</h3>
                        <p>Smart Uniform for Bright Minds</p>
                      
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="inds_3" style={{ backgroundImage: `url(${Inds7})` }} onClick={() =>
                      window.open("/product/government-police-defense", "_self")
                    }>
                        <h3>Government, Police & Defense</h3>
                        <p>Proudly Serving Those Who Serve</p>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ambience_and_harmony_section">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content ambience_contents" >
                  <h2>Ambience and Harmony</h2>
                  <h3>Invisible Luxury, Designed for Your Space</h3>
                  <p>From bedding and bath essentials to spa wear and décor, our custom textile solutions embody your property’s character. We combine elegance, function, and brand expression to elevate every guest experience.</p>
                  <h4>Our Promise</h4>
                  <ul>
                    <li>Bespoke Designs</li>
                    <li>Luxury & Comfort</li>
                    <li>End-to-End Solution</li>
                    <li>Built for Longevity</li>
                  </ul>
                </div>
                <div data-animate="bottom" className="animeslide-desc">
                  <a href="/ambience-and-harmony"><span>Learn More</span><img src={Icon1} alt="" /></a>
                </div>
              </div>
            </div>
            <div className="col-sm-6 ambiencecolmbr">
              <div className="ambience_imgs">
                <div className="row" style={{ margin: 0 }}>
                  <div className="col-sm-5">
                    <img src={Amb1} alt="" className='logom' />
                    <img src={Amb3} alt="" className='logom' />
                  </div>
                  <div className="col-sm-7">
                    <img src={Amb2} alt="" className='logom' />
                    <img src={Amb4} alt="" className='logom' />
                    <img src={Amb5} alt="" className='ambience_img' />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our_work_section">
        <div className="container">
          <div className="work_title brands_content">
            <h2>Our Work</h2>
          </div>
          <div className="our_work_content">
            <div class="swiper mySwiper our_work instpostslide">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div className="our_first_work">
                    <img src={Work1} alt="" className='logom' />
                    <div className="our_first_work_content">
                      <h4>Front Desk Uniforms</h4>
                      <p>Sharp, modern uniforms tailored for hospitality professionals, combining style with comfort.</p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div className="our_first_work">
                    <img src={Work2} alt="" className='logom' />
                    <div className="our_first_work_content">
                      <h4>Culinary Wear</h4>
                      <p>Chef coats and kitchen attire designed for durability, mobility, and a professional look.</p>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div className="our_first_work">
                    <img src={Work3} alt="" className='logom' />
                    <div className="our_first_work_content">
                      <h4>Housekeeping Apparel</h4>
                      <p>Practical and elegant uniforms that keep staff comfortable while maintaining a polished image.</p>
                    </div>
                  </div>
                </div>
                 <div class="swiper-slide">
                  <div className="our_first_work">
                    <img src={Work3} alt="" className='logom' />
                    <div className="our_first_work_content">
                      <h4>Housekeeping Apparel</h4>
                      <p>Practical and elegant uniforms that keep staff comfortable while maintaining a polished image.</p>
                    </div>
                  </div>
                </div>
              </div>
<div class="swiper-paginationnn"></div>
            </div>
            
          </div>
        </div>
      </section>
      <section className="get_in_touch_section" style={{ backgroundImage: `url(${Get1})` }}>
        <div className="container">
          <div className="row get_in_touch">
            <div className="col-sm-5 get_in_touch_left">
              <div className="get_in_touch_lefts">
                <div className="brands_content get_content" >
                  <h2>Get In Touch</h2>
                  <p>Every great idea begins with a chat. Let’s talk about your next project.</p>
                </div>
                <img src={Get2} alt="" className='get_in_touch' />
              </div>
            </div>
            <div className="col-sm-6 touchmbrweb">
              <div className="get_in_touch_right">

              <ContactForm />

              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="our_process_section">
        <div className="container">
          <div className="row">
            <div className="brands_content process_content mbrprocess_content  " >
              <h2>OUR PROCESS: FROM SKETCH TO STITCH</h2>
              <p>From understanding your brand to delivering the finished product, we perfect every step.</p>
            </div>
            <div className="process_content_img" >
              <div className="process_content_img_1" >
                <img src={Pro1} alt="" className='logom heightimg' />
                <h3>1. BRAND REQUIREMENT</h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro2} alt="" className='logomm' />

              </div>
              <div className="process_content_img_1" >
                <img src={Pro3} alt=""  className='logom heightimg' />
                <h3>2. PRODUCT DESIGN</h3>

              </div>
              <div className="process_content_img_1" >
                <img src={Pro4} alt="" className='logomm' />

              </div>
              <div className="process_content_img_1" >
                <img src={Pro5} alt="" className='logom heightimg' />
                <h3>3. SAMPLING AND PRODUCT DEV</h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro6} alt="" className='logomm' />
                <h3></h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro7} alt="" className='logom heightimg' />
                <h3>4. FORECASTING</h3>
              </div>
              <div className="process_content_img_2" >
                <h2>Share Your Vision. We’ll<br></br> Bring It to Life</h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Get In Touch</span> </a>
                </div>
              </div>
              <div className="process_content_img_1 " >

              </div>
              <div className="process_content_img_1" >
                <img src={Pro9} alt="" className='logom heightimg' />
                <h3>7. DELIVERY</h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro12} alt="" className='logomm' />
                <h3></h3>
              </div>
              <div className="process_content_img_1" >
                <img src={Pro11} alt="" className='logom heightimg' />
                <h3>6. WAREHOUSING AND SHIPPING</h3>
              </div>

              <div className="process_content_img_1" >
                <img src={Pro10} alt="" className='logomm' />
              </div>

              <div className="process_content_img_1" >
                <img src={Pro13} alt="" className='logom heightimg' />
                <h3>5. MANUFACTURING</h3>
              </div>

              <div className="process_content_img_1" >
                <img src={Pro8} alt="" className='process_img' />

              </div>
              <div className="process_content_img_2 mobile" >
                <h2>Share Your Vision. We’ll<br></br> Bring It to Life</h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop">Get In Touch</a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="global_footprint_section">
        <div className="container">
          <div className="brands_content global_title" >
            <h2>Global Footprint</h2>
          </div>
          <img src={Global1} alt="" className='logom' />
        </div>
      </section>
      <CustomerSay />






    










    </>



  );
};

export default HomePage;
